const n = {
  name: "Linkedin",
  dimensions: { width: 40, height: 40 },
  content: '<path fill="currentColor" stroke="none" d="M31.6667 0H8.33333C3.73333 0 0 3.73333 0 8.33333V31.6667C0 36.2667 3.73333 40 8.33333 40H31.6667C36.2667 40 40 36.2667 40 31.6667V8.33333C40 3.73333 36.2667 0 31.6667 0ZM13.3333 31.6667H8.33333V13.3333H13.3333V31.6667ZM10.8333 11.2167C9.21667 11.2167 7.91667 9.9 7.91667 8.28333C7.91667 6.66667 9.21667 5.33333 10.8333 5.33333C12.45 5.33333 13.75 6.65 13.75 8.26667C13.75 9.88333 12.45 11.2167 10.8333 11.2167ZM33.3333 31.6667H28.3333V22.3333C28.3333 16.7167 21.6667 17.15 21.6667 22.3333V31.6667H16.6667V13.3333H21.6667V16.2833C24 11.9667 33.3333 11.65 33.3333 20.4167V31.6667Z"/>'
};
export {
  n as Linkedin
};
